
export default [
  {
    title: 'Filtres',
    list: [
      {
        name: '(Aucun)',
        filter: ''
      },
      {},
      {
        name: 'Utilisateurs actifs',
        filter: 'non $r~ghost'
      }
    ]
  }
]
